import React from 'react'
import { Ticket, ShoppingCart, ShoppingBagOpen, Path as PdpJourneyIcon } from '@phosphor-icons/react'
import { JourneyStep } from 'src/lib/hooks/useNavigation'
import { permissionType } from 'src/lib/utils/constants'

export type ProgressStep = {
  id: JourneyStep
  title: string
  color: string
  isActive: boolean
  isEnabled: boolean
  buttonId: string
  plgRedirectionUrl?: string
  imageUrl: string
  icon?: JSX.Element
  shadowColor: string
}

export const createJourneyConfig = (
  journeyStep: JourneyStep,
  canAccess: (permission: string, level: number) => boolean,
  isUserConfigured: boolean,
  hasOverdueInvoices: boolean
): ProgressStep[] => [
    {
      id: JourneyStep.SHOP_PASS,
      buttonId: 'journey-shop-pass',
      title: 'Shop Pass',
      icon: <Ticket size={16} weight='fill' />,
      color: 'bg-violet-600',
      isActive: journeyStep === JourneyStep.SHOP_PASS,
      isEnabled: canAccess(permissionType.TAB_SSO, 0) && isUserConfigured && !hasOverdueInvoices,
      plgRedirectionUrl: '/sso/real-estate',
      imageUrl: 'https://image.shopflo.com/shop-pass-icon.svg',
      shadowColor: '#7c3aec'
    },
    {
      id: JourneyStep.PDP,
      buttonId: 'journey-pdp',
      title: 'Flo PDP',
      icon: <PdpJourneyIcon size={16} weight='fill' />,
      color: 'bg-emerald-500',
      isActive: journeyStep === JourneyStep.PDP,
      isEnabled: canAccess(permissionType.TAB_PDP, 0) && isUserConfigured && !hasOverdueInvoices,
      imageUrl: 'https://image.shopflo.com/pdp-icon.png',
      shadowColor: '#e60076'
    },
    {
      id: JourneyStep.CART,
      buttonId: 'journey-cart',
      title: 'Flo Cart',
      icon: <ShoppingBagOpen size={16} weight='fill' />,
      color: 'bg-sky-500',
      isActive: journeyStep === JourneyStep.CART,
      isEnabled: canAccess(permissionType.TAB_CART, 0) && isUserConfigured && !hasOverdueInvoices,
      plgRedirectionUrl: '/cart/real-estate',
      imageUrl: 'https://image.shopflo.com/cart-icon.svg',
      shadowColor: '#0ca5e9'
    },
    {
      id: JourneyStep.CHECKOUT,
      buttonId: 'journey-checkout',
      title: 'Flo Checkout',
      icon: <ShoppingCart size={16} weight='fill' />,
      color: 'bg-emerald-500',
      isActive: journeyStep === JourneyStep.CHECKOUT,
      isEnabled: isUserConfigured && !hasOverdueInvoices,
      imageUrl: 'https://image.shopflo.com/checkout-icon.svg',
      shadowColor: '#11b981'
    }
  ]
